/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'l4-policy';
const componentName = 'l4-rule-protocol-match';
const prefix = `${moduleName}.${componentName}`;

export const radioLabelMatchCriteriaIs = `${prefix}.radioLabelMatchCriteriaIs`;
export const radioLabelMatchCriteriaIsNot = `${prefix}.radioLabelMatchCriteriaIsNot`;
export const matchProtocolFieldLabel = `${prefix}.matchProtocolFieldLabel`;

export const ENGLISH = {
    [radioLabelMatchCriteriaIs]: 'Is',
    [radioLabelMatchCriteriaIsNot]: 'Is not',
    [matchProtocolFieldLabel]: 'L4 Rule Protocol',
};
